module.exports = __webpack_public_path__ + "static/media/si-dom.3e017cec.png";